var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9023 10.3669H9.85982C9.57993 10.3669 9.35285 10.1399 9.35285 9.85994V5.80429C9.35285 5.52399 9.57993 5.29746 9.85982 5.29746C10.1399 5.29746 10.3673 5.52399 10.3673 5.80429V9.35327H12.9023C13.182 9.35327 13.4092 9.57997 13.4092 9.85994C13.4092 10.1399 13.182 10.3669 12.9023 10.3669ZM9.99993 2.30762C5.75144 2.30762 2.30762 5.75166 2.30762 10C2.30762 14.2485 5.75144 17.6922 9.99993 17.6922C14.2483 17.6922 17.6922 14.2485 17.6922 10C17.6922 5.75166 14.2483 2.30762 9.99993 2.30762Z",
    fill: "#55595F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFilled);
export default __webpack_public_path__ + "static/media/ClockFilled.905e205ec97064bca3963fe12f7a337e.svg";
export { ForwardRef as ReactComponent };